<template>
  <div>
    <div class="mark">
      <i class="iconfont icon-chenggong-icon"></i>
    </div>
    <p class="warn">验证成功</p>
    <div class="shell">
      <a
        href="/supermarket/html/publicPage/myload.html"
        class="weui-btn weui-btn_warn btn"
        id="nextStep"
        >完成</a
      >
    </div>
  </div>
</template>
<script>
import { checkStatus } from './mixin';

export default {
  name: 'IdentifyUploadSuccess',
  data() {
    return {
      danger: 'danger',
    };
  },
  mixins: [checkStatus],
};
</script>
<style scoped>
.mark {
  padding-top: 110px;
}
.mark i {
  margin-top: 69px;
  color: #f5514a;
  font-size: 67px;
}
.warn {
  color: #1c2438;
  font-size: 19px;
  font-size: 700;
  text-align: center;
}
a {
  display: block;
  height: 50px;
  margin-top: 70px;
  color: #fff;
  font-size: 18px;
  line-height: 50px;
  background-color: #e64340;
  border-radius: 11px;
}
.tip {
  width: 3.45rem;
  height: 0.6rem;
  margin: 0 auto;
  margin-top: 0.08rem;
  color: #9ea7b4;
  font-size: 0.14rem;
  text-align: center;
}
.shell {
  padding-right: 20px;
  padding-left: 20px;
}

.btn {
  margin-top: 70px;
  margin-bottom: 25px;
}
.singlePho {
  width: 0.6rem;
  margin: 1rem 1.58rem 0 1.58rem;
}
.singlePho i {
  color: #f5514a;
  font-size: 0.6rem;
}
.result {
  color: #1c2438;
  font-weight: 700;
  font-size: 0.17rem;
  text-align: center;
}
.lists {
  margin-top: 0.08rem;
  color: #9ea7b4;
  font-size: 0.14rem;
  text-align: center;
}
.listsDetail {
  padding-right: 0.15rem;
  padding-left: 0.15rem;
}
.listsDetail p {
  color: #9ea7b4;
  font-size: 0.14rem;
  text-align: center;
}
.special {
  background-color: #b2b2b2 !important;
}
</style>
